import PropTypes from 'prop-types';
import { CSVDownload } from 'react-csv';

const propTypes = {
  data: PropTypes.array,
};

const slotFormat = slot => slot + 1

const pageFormat = page => page.value === 0 ? 'Finish Page' : `#${page.value} - ${page.name}`

const percent = value => `${(value * 100).toFixed()}%`

const money = value => `$ ${value}`

export default function ReportCsv({ data }) {
  const progressions = [];
  progressions.push(['path', 'slot', 'page', 'impressions', 'completed', 'completed percent', 'abandonment percent', 'revenue'])

  for (const path of data) {
    for (const slot of path.children) {
      const slotPosition = slot.value
      for (const page of slot.children) {
        const { completed, completedPC, abandonmentPC, revenue, total: impressions } = page

        progressions.push([pageFormat(path), slotFormat(slotPosition), pageFormat(page), impressions, completed, percent(completedPC), percent(abandonmentPC), money(revenue).toString()])
      }
    }
  }
  return (
    <CSVDownload data={progressions} target="_blank" />
  )
}

ReportCsv.propTypes = propTypes;
